/* angular */
import { createReducer, on } from '@ngrx/store';
/* models */
import { User } from 'src/app/features/shared/sdk/models';
/* actions */
import * as AuthDataStoreActions from './auth-data-store.actions';

/* state key */
export const featureKey = 'AuthDataStore';

/* state interface */
export interface AuthState {
  isLoading: boolean;
  token?: string;
  user?: User;
  unregisteredPhoneNumber?: boolean; // used to indicate if the phone number is not registered
}

/* initial values */
export const initialState: AuthState = {
  isLoading: false,
  token: null,
  user: null,
  unregisteredPhoneNumber: false, // default to false
};

export const reducer = createReducer(
  initialState,
  on(AuthDataStoreActions.SetUser, (state, action) => ({
    ...state,
    user: action.payload.user,
  })),
  on(AuthDataStoreActions.Register, (state, action) => ({
    ...state,
    isLoading: true,
  })),
  on(AuthDataStoreActions.GetTokenByCredentials, (state, action) => ({
    ...state,
    isLoading: true,
  })),
  on(AuthDataStoreActions.GetTokenByCredentialsFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),
  on(AuthDataStoreActions.GetTokenByCredentialsSuccessful, (state, action) => ({
    ...state,
    isLoading: false,
  })),
  on(AuthDataStoreActions.LoginByToken, (state, action) => ({
    ...state,
    isLoading: true,
  })),
  on(AuthDataStoreActions.LoggedIn, (state, action) => ({
    ...state,
    isLoading: false,
    token: action.payload.token,
  })),
  on(AuthDataStoreActions.GetOtpByPhoneNumberSuccessful, (state, action) => ({
    ...state,
    unregisteredPhoneNumber: false,
    isLoading: false,
  })),
  on(AuthDataStoreActions.GetOtpByPhoneNumberFailure, (state, action) => ({
    ...state,
    unregisteredPhoneNumber: true,
    isLoading: false,
  })),

  on(AuthDataStoreActions.LoginByTokenFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),
);
